module.exports = __webpack_public_path__ + "static/media/dog-boxer.e0adbac1.png";